<template>
    <div class="form-group" :class="'form-field-' + nameDashed" :id="$_id" v-bind="rowAttrs" v-show="isVisible()">
        <slot name="label" :scope="_self" v-if="displayLabel">
            <oc-label-input
                v-if="labelText !== null"
                v-text="labelText"
                :for="$_inputId"
                v-bind="labelAttrs"
                class="form-control-label"
                v-class="labelClasses"
            />

            <sup class="required-asterisk" v-if="isRequired()">*</sup>

            <slot v-if="helpUseIcon" name="help" :scope="_self">
                <oc-icon
                    type="question-circle"
                    v-if="help !== null"
                    :title="help"
                    v-bind="helpAttrs"
                    class="form-field-help form-field-help-question text-muted"
                />
            </slot>
        </slot>

        <div class="input-group" v-class="inputGroupClasses">
            <div class="input-group-prepend" v-if="hasInputPrepend">
                <span class="input-group-text">
                    <slot name="input-prepend" :scope="_self">
                        <template v-if="_isObject(inputPrepend)">
                            <component :is="inputPrepend.component" v-bind="inputPrepend.attrs" v-on="inputPrepend.on" />
                        </template>
                        <template v-else>
                            {{inputPrepend}}
                        </template>
                    </slot>
                </span>
            </div>

            <slot name="input" :scope="_self">
                <oc-field
                    v-model="model"
                    v-on="inputListeners"
                    :id="$_inputId"
                    :placeholder="placeholderText"
                    :name="name"
                    v-bind="processedInputAttrs"
                    :readonly="isLoading || isReadonly()"
                    :disabled="isDisabled()"
                    :class="'form-control' + (displayInputFeedback ? '' : ' hide-input-feedback')"
                    v-class="inputClasses"
                    ref="input"
                >
                    <template slot="view" slot-scope="viewAttrs">
                        <slot name="view" v-bind="viewAttrs"></slot>
                    </template>
                </oc-field>
            </slot>

            <div class="input-group-append" v-if="hasInputAppend || (displayLoader && isLoading)">
                <span class="input-group-text">
                    <span class="fa-1x" v-if="displayLoader && isLoading">
                        <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                        <i class="sr-only">Loading...</i>
                    </span>

                    <slot v-else name="input-append" :scope="_self">
                        <template v-if="_isObject($_inputAppend)">
                            <component :is="$_inputAppend.component" v-bind="$_inputAppend.attrs" v-on="$_inputAppend.on" />
                        </template>
                        <template v-else>
                            {{$_inputAppend}}
                        </template>
                    </slot>
                </span>
            </div>

            <slot name="feedback" v-bind="feedbackAttrs">
                <oc-form-feedback
                    v-if="displayFeedback"
                    v-bind="feedbackAttrs"
                    v-class="feedback.class"
                    ref="feedback"
                />
            </slot>
        </div>

        <slot v-if="! helpUseIcon" name="help" :scope="_self">
            <p
                v-if="help !== null"
                class="form-field-help form-text text-muted"
                v-text="help"
                v-bind="helpAttrs"
            />
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        inputGroupOptions: {
            type: Object,
            default: () => ({})
        },
        displayInputFeedback: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        inputGroupClasses() {
            let classes = [
                'input-group-' + this.$_size
            ]

            if( this.inputGroupOptions.class !== undefined ) {
                 classes = [classes, this.inputGroupOptions.class]
            }

            return classes
        }
    }
}
</script>

<style scoped>
    .required-asterisk {
        color:red;
    }
    .form-group .input-group .form-control {
        height: auto;
    }
    .form-group .form-field-help-question {
        color: #b1b1b1 !important;
        text-indent: 2px;
        font-size:15px;
        vertical-align: baseline;
    }

    .hide-input-feedback.form-control.is-valid,
    .hide-input-feedback.form-control.is-invalid {
        background-image: none;
        padding: 6px 12px;
    }

    .hide-input-group-sm .input-feedback.form-control.is-valid,
    .hide-input-group-sm .input-feedback.form-control.is-invalid {
        padding: .25rem .5rem;
    }
</style>
